import { render } from "./SystemDbAnalyzer.vue?vue&type=template&id=71fcd00a&scoped=true"
import script from "./SystemDbAnalyzer.vue?vue&type=script&lang=js"
export * from "./SystemDbAnalyzer.vue?vue&type=script&lang=js"

import "./SystemDbAnalyzer.vue?vue&type=style&index=0&id=71fcd00a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71fcd00a"]])

export default __exports__